import AddinActivator from './AddinActivator';
import Extension from 'owa-service/lib/contract/Extension';
import setAddinCommandsForOptions from './utils/setAddinCommandsForOptions';
import { EnabledAddinCommands, IAddin, setEnabledAddinCommands } from 'owa-addins-store';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { removeUninstalledPersistedAddins } from 'owa-addins-persistent';

export default function enableAddinCommands(
    activeExtensions: Extension[],
    addinActivator: AddinActivator
) {
    const enabledAddinCommands: EnabledAddinCommands = new EnabledAddinCommands();
    return addinActivator
        .activate(activeExtensions, ExtensibilityModeEnum.AppointmentAttendee)
        .then((data: IAddin[]) => {
            enabledAddinCommands.setExtensionPoint(data, ExtensibilityModeEnum.AppointmentAttendee);
            return addinActivator.activate(
                activeExtensions,
                ExtensibilityModeEnum.AppointmentOrganizer
            );
        })
        .then((data: IAddin[]) => {
            enabledAddinCommands.setExtensionPoint(
                data,
                ExtensibilityModeEnum.AppointmentOrganizer
            );
            return addinActivator.activate(activeExtensions, ExtensibilityModeEnum.DetectedEntity);
        })
        .then((data: IAddin[]) => {
            enabledAddinCommands.setExtensionPoint(data, ExtensibilityModeEnum.DetectedEntity);
            return addinActivator.activate(activeExtensions, ExtensibilityModeEnum.MessageRead);
        })
        .then((data: IAddin[]) => {
            enabledAddinCommands.setExtensionPoint(data, ExtensibilityModeEnum.MessageRead);
            return addinActivator.activate(activeExtensions, ExtensibilityModeEnum.MessageCompose);
        })
        .then((data: IAddin[]) => {
            enabledAddinCommands.setExtensionPoint(data, ExtensibilityModeEnum.MessageCompose);
            return addinActivator.activate(activeExtensions, ExtensibilityModeEnum.MeetingRequest);
        })
        .then((data: IAddin[]) => {
            enabledAddinCommands.setExtensionPoint(data, ExtensibilityModeEnum.MeetingRequest);
            return addinActivator.activate(activeExtensions, ExtensibilityModeEnum.TrapOnSendEvent);
        })
        .then((data: IAddin[]) => {
            enabledAddinCommands.setExtensionPoint(data, ExtensibilityModeEnum.TrapOnSendEvent);
        })
        .then(() => {
            enabledAddinCommands.isInitialized = true;
            setEnabledAddinCommands(enabledAddinCommands);
            setAddinCommandsForOptions(enabledAddinCommands);
            const addinIds = activeExtensions.map((extension: Extension) => extension.Id);
            removeUninstalledPersistedAddins(addinIds);
        });
}
